module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Ka-Ld.702c2a02.png";